export const isViewPageLite = (): boolean => window?.location?.search?.indexOf('lite=1') >= 0;
